import React, { useState, useEffect, useRef } from 'react';
import "./FindPage.css"
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';




const FindPage = () => {

  return (
    <div className='logincontainer'>
        <div className='logincomponent'>
            <div className='logintitle'>
                <h1>D-ROAD</h1>
            </div>
            <Box sx={{ width: 500, maxWidth: '100%' }}>
                <TextField fullWidth label="아이디" id="E-Mail" />
            </Box>
            <Box sx={{ width: 500, maxWidth: '100%' }}>
                <TextField fullWidth label="이름" id="이름" />
            </Box>
            
            <div>
           

            </div>
            <div className='loginbtn'>
                <h3>로그인 하러 가기</h3>
            </div>
            <div className='signuplink'>
                계정이 없으신가요? 회원가입
            </div>
        </div>
   </div>
  );
};

export default FindPage;

